import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { showSalary } from "../../../../utilities/showsalary";
import bgphoto from "../../../../../src/assets/img/images/teamanics_logo.png";
import orgImage from "../../../../../src/assets/img/images/office.jpeg";
import { ProfileService } from "../../../../services/ProfileService";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Input } from "reactstrap";
import { getEnumLists } from "../../../../services/MetadataService";
import JobSuggestions from "./jobsuggestions";
import { ENV } from "../../../../config/ENV";
import { Stringutility } from "../../../../utilities/stringutility";
import { Constants } from "../../../../constants/constantValues";
import { StorageService } from "../../../../services/StorageService";
import { StorageValues } from "../../../../constants/storageValues";
import { GenericCodes } from "../../../../constants/genericCodeValues";
import AllJobs from "../AllJobs/allJobs";
import TeamanicsButton from "../../../../buttoncomponent/TeamanicsButton";

const Jobs = () => {
  const history = useHistory();
  const [appliedjobs, setAppliedJobs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [appliedId, setAppliedId] = useState("");
  const [saveDocConfirmBtnEnabled, setSaveDocConfirmBtnEnabled] =
    useState(false);
  const [closeDocConfirmBtnEnabled, setCloseDocConfirmBtnEnabled] =
    useState(false);

  const [notes, setNotes] = useState();

  const inputsHandler = (e) => {
    setNotes(e.target.value);
  };

  const [isLoading, setIsLoading] = useState(true);
  const navigateTo = (id) => {
    const jobIdReq = { jobId: id };
    history.push("/jobdetails", jobIdReq);
  };

  useEffect(() => {
    scrollToTop();
    let jobStatus = StorageService.getFromLocalStorage(StorageValues.jobStatus);
    let jobId = StorageService.getFromSessionStorage(StorageValues.JOB_ID);

    if (!Stringutility.isNullOrEmpty(jobStatus)) {
      if (jobStatus !== "applied") {
        if (!Stringutility.isNullOrEmpty(jobId)) {
          candidateApplyForJob(jobId);
        }
      }
    } else if (!Stringutility.isNullOrEmpty(jobId)) {
      candidateApplyForJob(jobId);
    }

    StorageService.saveInSessionStorage(StorageValues.APPLY_JOB, "");
    getappliedJobs();

    getEnums();
  }, []);

  const getEnums = () => {
    getEnumLists().then((response) => {
      try {
        if (response.data !== null) {
          var enumDetails = response.data;
          window.localStorage.setItem(
            "enumsLists",
            JSON.stringify(enumDetails)
          );
        }
      } catch (err) {
        console.error("getEnumLists " + JSON.stringify(err));
      }
    });
  };

  const scrollToTop = () => {
    const element = document.getElementById("scrollToTop");
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getJobBenefits = (jobBenefits) => {
    const bList = [];
    const maxBenefitsToShow = 10;
    let count = 0;
    const benefitsArray = [
      { key: "cobra", label: "Cobra" },
      { key: "Disability", label: "Disability" },
      { key: "medicalLeave", label: "MedicalLeave" },
      { key: "minimumWage", label: "MinimumWage" },
      { key: "overtime", label: "Overtime" },
      { key: "unEmploymentBenefit", label: "UnEmploymentBenefit" },
      { key: "WorkerCompensation", label: "WorkerCompensation" },
      { key: "bonusPay", label: "BonusPay" },
      { key: "compensation401k", label: "401k" },
      { key: "stockOption", label: "StockOption" },
      { key: "health", label: "Health" },
      { key: "dental", label: "Dental" },
      { key: "vision", label: "Vision" },
      { key: "lifeInsurance", label: "Life Insurance" },
      { key: "paidHoliday", label: "Paid Holidays" },
      { key: "paidSickTime", label: "Paid SickTime" },
      { key: "paidVacation", label: "Paid Vacation" },
      { key: "flexibleHour", label: "Flexible Hour" },
      { key: "parentalLeave", label: "Parental Leave" },
      { key: "tuition", label: "Tuition" },
      {
        key: "profDeveAssistance",
        label: "Professional Development Assistance ",
      },
      { key: "empDiscount", label: "Employee Discounts" },
    ];

    for (const benefit of benefitsArray) {
      if (jobBenefits[benefit.key] && count < maxBenefitsToShow) {
        bList.push(
          <span
            key={benefit.key}
            className="inline-block mb-1 bg-Gray-600 font-semibold text-white text-xs rounded-[4px] mr-1 px-2 pb-[2px]"
          >
            {benefit.label}
          </span>
        );
        count++;
      }
    }
    return <div>{bList}</div>;
  };
  const getTotalSelectedBenefits = (moBenefits) => {
    var add = [];
    if (moBenefits.cobra) {
      add.push("Cobra");
    }
    if (moBenefits.Disability) {
      add.push("Disability");
    }
    if (moBenefits.medicalLeave) {
      add.push("MedicalLeave");
    }
    if (moBenefits.minimumWage) {
      add.push("MinimumWage");
    }
    if (moBenefits.overtime) {
      add.push("overtime");
    }
    if (moBenefits.unEmploymentBenefit) {
      add.push("UnEmploymentBenefit");
    }
    if (moBenefits.WorkerCompensation) {
      add.push("WorkerCompensation");
    }
    if (moBenefits.bonusPay) {
      add.push("BonusPay");
    }
    if (moBenefits.compensation401k) {
      add.push("401k");
    }
    if (moBenefits.stockOption) {
      add.push("StockOption");
    }
    if (moBenefits.health) {
      add.push("Health");
    }
    if (moBenefits.dental) {
      add.push("Dental");
    }
    if (moBenefits.vision) {
      add.push("Vision");
    }
    if (moBenefits.lifeInsurance) {
      add.push("Life Insurance");
    }
    if (moBenefits.paidHoliday) {
      add.push("Paid Holidays");
    }
    if (moBenefits.paidSickTime) {
      add.push("Paid SickTime");
    }
    if (moBenefits.paidVacation) {
      add.push("Paid Vacation");
    }
    if (moBenefits.flexibleHour) {
      add.push("Flexible Hour");
    }
    if (moBenefits.parentalLeave) {
      add.push("Parental Leave");
    }
    if (moBenefits.tuition) {
      add.push("Tuition");
    }
    if (moBenefits.profDeveAssistance) {
      add.push("Professional Development Assistance");
    }
    if (moBenefits.empDiscount) {
      add.push("Employee Discounts");
    }
    return add.join(", ");
  };
  const getappliedJobs = () => {
    ProfileService.getAppliedJobsService().then((response) => {
      try {
        var appliedjobs = response.data;
        if (appliedjobs !== null) {
          setIsLoading(false);
          setAppliedJobs(response.data.appliedJobs);
        }
        else 
        {
          setIsLoading(false);
        }
      } catch (err) {
        console.error("getAppliedJobsService" + JSON.stringify(err));
      }
    });
  };
  const minimumFractionDigits = 2;

  const withdrawJob = () => {
    if (Stringutility.isNullOrEmpty(notes)) {
      Stringutility.showErrorMessage(Constants.enterReason);
      return;
    }

    const dataObj = {
      notes: notes,
    };
    ProfileService.withdrawService(appliedId, dataObj).then((response) => {
      try {
        var data = response.data;
        if (data !== null) {
          // toast.success("Candidate withdraw job successfully");
          setShowModal(false);
          getappliedJobs();
        }
      } catch (err) {
        console.error("withdrawService" + JSON.stringify(err));
      }
    });
  };

  const candidateApplyForJob = (jobId) => {
    const jobRequest = {
      jobId: jobId,
    };
    ProfileService.applyForJob(jobRequest).then((response) => {
      try {
        if (response.data != null) {
          if (response.status === 200) {
            Stringutility.showSuccessMessage(Constants.appliedJobSuccessfully);
            getappliedJobs();
          } else {
            if (
              response.data.failure_code === GenericCodes.jobAppliedPreviously
            ) {
              Stringutility.showErrorMessage(Constants.appliedJobPreviously);
            } else if (response.data.failure_code === GenericCodes.invalidJob) {
              Stringutility.showErrorMessage(Constants.invalidJob);
            } else if (
              response.data.failure_code === GenericCodes.jobIsNotActive
            ) {
              Stringutility.showErrorMessage(Constants.invalidJob);
            }
          }
          StorageService.removeItemInSessionStorage(StorageValues.APPLY_JOB);
          StorageService.removeItemInSessionStorage(StorageValues.JOB_ID);
        }
      } catch (err) {
        console.error("applyForJob" + JSON.stringify(err));
      }
    });
  };

  const onReasonFileChange = (id) => {
    setNotes("");
    setAppliedId(id);
    setSaveDocConfirmBtnEnabled(false);
    setCloseDocConfirmBtnEnabled(false);

    setShowModal(true);
  };

  const handleModelClose = () => {
    setShowModal(false);
  };

  const displayLocation = (location) => {
    var arr = [];
    if (!Stringutility.isNullOrEmpty(location.city)) {
      arr.push(location.city);
    }
    if (!Stringutility.isNullOrEmpty(location.state)) {
      arr.push(location.state);
    }
    if (!Stringutility.isNullOrEmpty(location.zipcode)) {
      arr.push(location.zipcode);
    }
    return arr.join(", ");
  };

  const showSalaryType = (salaryType) => {
    if (salaryType !== null) {
      if (!Stringutility.isNullOrEmpty(salaryType)) {
        if (salaryType.key === "HOURLY") {
          return "hour";
        } else if (salaryType.key === "ANNUAL") {
          return "year";
        } else if (salaryType.key === "MONTHLY") {
          return "month";
        }
        return salaryType.value;
      }
    }
  };

  const viewJobApplyStatus = (appliedJob) => {
    var jobStatus = "";
    var jobApplicationStatus = appliedJob.jobApplicationStatus;
    if (jobApplicationStatus !== null) {
      jobStatus = jobApplicationStatus.value;

      return (
        <div className="bg-Blue-200 rounded-md text-center text-sm text-black font-semibold p-1 inline-block mt-4 max-md:pt-[4px] px-[10px] pb-[6px] ">
          <span className="bg-primary-blue3 inline-block w-2 h-2 mr-1 rounded-full"></span>{" "}
          {jobStatus}
        </div>
      );
    } else {
      return <></>;
    }
  };

  const checkJobSalary = (jobResponse) => {
    if (jobResponse !== null) {
      let salaryMin = jobResponse.salaryMin;
      let salaryMax = jobResponse.salaryMax;
      let salaryType = jobResponse.salaryType;

      if (salaryMin == 0 && salaryMax == 0) {
        return <></>;
      } else if (salaryMin !== 0 && salaryMax == 0) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else if (salaryMin == 0 && salaryMax !== 0) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {" "}
            {"$" + showSalary(salaryMax, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else if (salaryMin == salaryMax) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {" "}
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {" "}
            {"$" +
              showSalary(salaryMin, salaryMin, salaryMax) +
              "-" +
              "$" +
              showSalary(salaryMax, salaryMin, salaryMax)}
            /{showSalaryType(salaryType)}{" "}
          </div>
        );
      }
    }
  };
  const discourseOnClick = () => {
    StorageService.removeItemInLocalStorage(StorageValues.PAGE);
    const discourse_url = ENV.discourse_session_url;
    window.open(discourse_url, "_blank");
  };

  const handleAllJobs=()=>{
    history.push("/alljobs");
  }
  const handleFindJobs=()=>{
    history.push("/findJobs");
  }

  return (
    <>
      <div
        className="myjobs_container 
                    order-2 
                    max-lg:col-span-1 min-lg:col-span-3 min-xl:col-span-3 min-2xl:col-span-2
                    min-md:row-span-3 "
      >
        <h1 className="text-2xl font-bold mb-3 max-md:mb-1 max-md:ml-4 text-Gray-900 ">
          My Jobs
        </h1>

        {/* MyJobs Outer Container  */}
        <div className="myJobsOuter min-md:col-span-2 max-md:col-span-full  max-w-full max-md:order-3 ">
          {/* MyJobs Container  */}
          <div
            className={`myJobs_container min-md:pr-3 rounded-xl
            min-xl:max-h-[640px] max-xl:pb-4 bg-no-repeat bg-cover ${
              appliedjobs.length > 2 ? "overflow-y-scroll  max-xl:overflow-x-scroll min-xl:overflow-y-scroll scrollbar-thumb-roundedscrollbar-thin scrollbar-thumb-Blue-700  hover:scrollbar-thin scrollbar-thin  scrollbar-track-Gray-200" : ""
            }`}
          >
            {/* MyJobs Wrapper  */}
            <div className="MyJobs_wrapper flex gap-4 w-auto min-xl:min-h-[100px] min-md:w-auto min-xl:w-full min-md:flex-nowrap min-xl:flex-wrap min-md:flex-row min-xl:flex-col max-md:flex-row max-md:px-4 ">
              {/* MyJob Card */}

              {appliedjobs.length > 0 ? (
                appliedjobs.map((appliedjob, index) => {
                  return (
                    <div
                      key={index}
                      className="MyJob flex min-md:flex-col min-xl:flex-row min-md:min-w-[350px] min-xl:w-full bg-primary-white t-shadow-lg rounded-xl max-md:pb-4 overflow-hidden w-full min-md:gap-4 max-md:min-w-[350px] h-[350px] max-md:flex-wrap max-md:flex-col "
                    >
                      <div className="MyJob_logo relative min-md:w-full min-md:basis-3/5 min-lg:basis-3/5 min-2xl:basis-1/3 flex items-start overflow-hidden bg-primary-white shadow-md  min-md:h-[350px] min-xl:h-[350px] max-md:h-fit ">
                        {appliedjob.jobResponse.displayAccountInfo ? (
                          !Stringutility.isNullOrEmpty(
                            appliedjob.jobResponse.account.bgImage
                          ) ? (
                            <img
                              className="w-full h-[100%]  "
                              src={appliedjob.jobResponse.account.bgImage}
                              alt="Company"
                            />
                          ) : (
                            <img
                              className="w-full h-[100%] "
                              src={orgImage}
                              alt="Company"
                            />
                          )
                        ) : (
                          <img
                            className="w-full h-[100%] "
                            src={orgImage}
                            alt="Company"
                          />
                        )}
                        <div className="myjob_company h-[64px] w-[64px] items-center border-primary-gray2 border rounded-lg p-1 max-w-[64px] mt-[10px] ml-[10px] bg-white shadow-4xl absolute flex">
                          {appliedjob.jobResponse.displayAccountInfo ? (
                            !Stringutility.isNullOrEmpty(
                              appliedjob.jobResponse.account.logo
                            ) ? (
                              <img
                                className="w-full h-auto "
                                src={appliedjob.jobResponse.account.logo}
                                alt="Company"
                              />
                            ) : (
                              <img
                                className="w-full h-auto"
                                src={bgphoto}
                                alt="Company"
                              />
                            )
                          ) : (
                            <img
                              className="w-full h-auto"
                              src={bgphoto}
                              alt="Company"
                            />
                          )}
                        </div>
                      </div>
                      {/* MyJob Details  */}
                      <div className=" relative min-md:basis-2/3 min-md:flex min-md:flex-col min-xl:grid-cols-2 min-xl:grid-rows-2 min-md:gap-4 min-xl:gap-7 min-md:pb-4 min-xl:py-4 min-md:px-4 min-xl:pr-4 min-xl:pl-2  max-md:flex max-md:flex-wrap max-md:gap-3 max-md:px-4 ">
                        <div className="MyJob_info col-span-2  max-md:basis-2/3 max-md:order-1">
                          <span onClick={() => navigateTo(appliedjob.id)}>
                            <a
                              href=""
                              className="text-lg font-bold text-primary-blue min-xl:pt-3 max-md:pt-2 inline-block"
                            >
                              {" "}
                              {appliedjob.jobResponse.title}
                            </a>
                          </span>
                          <p className="text-primary-dark font-semibold text-sm mb-0">
                            {appliedjob.jobResponse.displayAccountInfo &&
                              appliedjob.jobResponse.account != null &&
                              !Stringutility.isNullOrEmpty(
                                appliedjob.jobResponse.account.name
                              ) && <>{appliedjob.jobResponse.account.name}</>}

                            {/* {appliedjob.jobResponse.displayAccountInfo ==
                            true ? (
                              <></>
                            ) : (
                              <>
                                {appliedjob.jobResponse.account != null &&
                                  !Stringutility.isNullOrEmpty(
                                    appliedjob.jobResponse.account.name
                                  ) && (
                                    <>{appliedjob.jobResponse.account.name}</>
                                  )}
                              </>
                            )} */}
                          </p>

                          {appliedjob.jobResponse.location != null ? (
                            appliedjob.jobResponse.location.address != null ? (
                              <p className="text-Gray-600 font-normal text-sm mb-0">
                                {displayLocation(
                                  appliedjob.jobResponse.location.address
                                )}
                              </p>
                            ) : (
                              <>&nbsp;&nbsp;</>
                            )
                          ) : appliedjob.jobResponse.remoteLocation ? (
                            <p>Remote Location</p>
                          ) : (
                            <>&nbsp;&nbsp;</>
                          )}

                          {/* <p className="text-Gray-600 font-normal text-sm"> Walnut Creek, CA </p>  */}
                        </div>
                        {/* MyJob Pay & Benefits  */}
                        <div className="MyJob_pay min-md:col-span-2 max-md:order-3 max-md:basis-4/5">
                          {appliedjob.jobResponse.showPay == false ? (
                            <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                          ) : (
                            <>{checkJobSalary(appliedjob.jobResponse)}</>
                          )}

                          <div className="block"></div>
                          <div className="JobPreferences t-benefits-container">
                            {/* <div className="jobpreference_container relative grid col-span-3 border-1 border-primary-gray  min-sm:rounded-2xl   w-full">
                              <div className="preferences-tags w-full overflow-x-hidden">
                                <div className="w-auto overflow-x-scroll scrollbar-none scrollbar-thumb-rounded-md scrollbar-thumb-Blue-600 scrollbar-track-Gray-200 pb-1">
                                  <div className="pref-tags flex flex-row flex-nowrap gap-1 touch-pan-x w-[auto]"> */}
                            {appliedjob.jobResponse.jobBenefits != null ? (
                              <>
                                <span
                                  className="  rounded-[4px] font-semibold text-xs text-primary-white min-w-max  px-2 py-1 t-hand-cursor-pointer"
                                  title={getTotalSelectedBenefits(
                                    appliedjob.jobResponse.jobBenefits
                                  )}
                                >
                                  {getJobBenefits(
                                    appliedjob.jobResponse.jobBenefits
                                  )}
                                </span>
                              </>
                            ) : (
                              <div className="mt-3">&nbsp;&nbsp;</div>
                            )}
                            {/* </div>
                                </div>
                              </div>
                            </div> */}
                          </div>

                          {viewJobApplyStatus(appliedjob)}
                        </div>
                        {/* MyJob Pay & Benefits End  */}

                        {/* MyJob Options  */}
                        <div
                          id="nav-toggle"
                          className="group cursor-pointer max-md:drop-shadow-2xl hover:drop-shadow-sm transition-all ease-in-out z-40 absolute top-0 max-md:top-4 right-0"
                        >
                          <div className="myjob_options absolute right-10 min-md:top-4 min-xl:top-7 z-40 max-lg:right-4 max-lg:top-2">
                            <span className="bg-primary-dark block w-1 h-1 m-1 rounded-full"></span>
                            <span className="bg-primary-dark block w-1 h-1 m-1 rounded-full"></span>
                            <span className="bg-primary-dark block w-1 h-1 m-1 rounded-full"></span>
                          </div>
                          {/* Candidate Menu */}

                          <nav className="hidden group-hover:block dropdown absolute z-30 right-[15px] min-md:top-0 min-xl:top-4 w-[170px] bg-transparent h-20 ">
                            <div className="relative max-md:absolute text-primary-dark tracking-widest font-semibold w-full text-sm z-30 shadow-lg rounded-lg transition ease-in-out">
                                <ul className="jobOptions absolute z-40 flex flex-col rounded-lg gap-1 left-0 right-0 py-[12px] top-12 bg-primary-white border border-primary-gray2 shadow-xl t-kabab-menu ">
                                    <li className="py-[7px]  px-3 hover:text-Gray-500 menuItem">
                                    <a href=""onClick={() => navigateTo(appliedjob.id)}>
                                            {/* Save Job */}
                                            Job Details
                                        </a>
                                    </li>
                                    <li
                                  className="py-3  px-3 hover:text-Gray-500  menuItem"
                                  onClick={(e) =>
                                    onReasonFileChange(appliedjob.id)
                                  }
                                > 
                                        <a href="#">
                                            Withdraw Job Application
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                        </div>
                        {/* MyJob Options End  */}
                      </div>
                      {/* MyJob Details End  */}
                    </div>
                  );
                })
              ) : (
                <>
                  {isLoading == false && (
                  <div className="welcomeWrapper relative grid max-md:gap-4 min-md:gap-7 
                  max-md:grid-cols-6 min-md:grid-cols-6 
                  bg-primary-white min-md:rounded-3xl min-md:shadow-lg 
                  max-md:px-4 min-md:px-7 max-md:pb-7 max-md:pt-7 pb-3 t-myprofile-btn">
                    <div className=" mt-2 fitscore min-sm:col-span-2 t-responsive-alljobs">
                      <TeamanicsButton className=" mt-2" onClick={handleAllJobs}>
                        See All Job Openings
                      </TeamanicsButton>
                      </div>
                      </div>
                  )}
               
                </>
              )}
            </div>
          </div>
        </div>
        <div className="jobsuggestions_container max-md:order-4 min-md:order-4 col-span-full mb-10 t-sugg-margin-bottom">
     <div className=" mt-6
                 mb-3 max-md:ml-4 text-Gray-900"
        >
          <strong onClick={discourseOnClick}>Community</strong>
        </div>
        {/* <TeamanicsButton className=" mt-2" onClick={handleFindJobs}>
                        Find Jobs
                      </TeamanicsButton> */}
      </div>
      </div>

      <div className="jobsuggestions_container 
                    order-3 
                    max-lg:col-span-1 min-lg:col-span-2 min-2xl:col-span-1 
                    min-lg:row-span-2 min-xl:row-span-2 min-2xl:row-span-2 
                    min-lg:row-start-1 min-xl:row-start-1 min-2xl:row-start-1  
                    min-lg:col-start-4 min-2xl:col-start-3
                    flex min-lg:flex-col gap-4 max-lg:flex-col max-lg:flex-nowrap 
                    max-lg:px-5"
                >
                        <JobSuggestions />
                    </div>

     
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        onHide={handleModelClose}
        style={{ zIndex: "1325" }}
      >
        <Modal.Header>
          <strong>Reason</strong>
        </Modal.Header>
        <Modal.Body>
          <div className="dashboard-model">
            <form className="form-sample">
              <div className="row">
                <div className="col-md-12">
                  <Form.Group className="col">
                    <div className="col-sm-12">
                      <Input
                        type="textarea"
                        name="notes"
                        id="notes"
                        onChange={inputsHandler}
                        value={notes}
                      />
                    </div>
                  </Form.Group>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer className="t-modal-footer-btn">
        <Button
            type="button"
            color="primary"
            className="t-withdrawcancel-btn"
            data-dismiss="modal"
            onClick={handleModelClose}
            disabled={closeDocConfirmBtnEnabled}
          >
            Cancel
          </Button>
          <Button
            type="button"
            color="primary"
            className="t-withdraw-btn"
            onClick={withdrawJob}
            disabled={saveDocConfirmBtnEnabled}
          >
            Withdraw Job Application
          </Button>
        
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Jobs;